module.exports = __webpack_public_path__ + "static/media/klickly-logo-final.73b633bc.svg";